<div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
  </div>
  <div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
      <div class="container shapes-div">
        <div class="row">
          <div class="sign__shape">
            <img src="assets/images/man-1.png" alt="" class="man-1" />
            <img src="assets/images/man-2.png" alt="" class="man-2" />
            <img src="assets/images/circle.png" alt="" class="circle" />
            <img src="assets/images/zigzag.png" alt="" class="zigzag" />
            <img src="assets/images/dot.png" alt="" class="dot" />
            <img src="assets/images/sign-up.png" alt="" class="bg" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xl-8 offset-xl-2">
            <div class="section__title-wrapper text-center mb-5">
              <!-- <h2 class="section__title">Sign In</h2> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
            <div class="sign__wrapper white-bg">
              <div class="sign__header mb-5">
                <div class="sign__in text-center">
                  <h2>DEB</h2>
                </div>
              </div>
              <div class="sign__form">
               <form [formGroup]="debRegisterationForm" novalidate>
                <div class="sign__input-wrapper mb-2">
                    <h6>Step 01: I do not have ABC ID</h6>
                </div>
                <div>
                    <button class="e-btn w-100 colfff" type="submit" (click)="createABCID()">Create ABC ID</button>
                </div>
                <div class="mt-2">
                    <span><i>After creation of ABC ID, create DEB ID in Step 02</i></span>
                </div>
                <div class="sign__input-wrapper mt-4">
                    <h6>Step 02: I already have / created ABC ID</h6>
                </div>
                <div>
                    <span><i>Use your ABC ID to create DEB ID</i>
                        <!-- <button class="e-btn w-100 colfff" type="submit" (click)="createDEBID()">Here</button> -->
                        <a href="https://deb.ugc.ac.in/StudentDEBId" class="e-btn w-100 colfff" target="_blank" rel="noopener">Create DEB ID</a>

                    </span>
                    <span class="mt-2"><i>After successful creation of DEB ID, please close the window and come back to this page again to provide DEB ID in Step 03 for admission at KKHSOU.</i></span>
                </div>
                <div class="sign__input-wrapper mt-4">
                    <h6>Step 03: Register at KKHSOU for new admission</h6>
                        <div class="sign__input">
                            <input type="text"  formControlName="DEBID" placeholder="Enter DEB ID" required/>
                            <mat-error class="margin_tp"
                            *ngIf="debRegisterationForm.controls['DEBID'].touched && debRegisterationForm.controls['DEBID'].errors?.required">
                            Mandatory.
                        </mat-error>
                            <button class="e-btn w-100 colfff mt-2" type="submit" (click)="getUserDetails()">Get your details</button>
                          </div>
                </div>
                <div class="sign__input-wrapper mt-4 center">
                    <h6 class="text-center">OR</h6>
                </div>
                <div class="sign__input-wrapper mt-4">
                    <h6>Step 04: Already Completed the above steps from 01 to 03.</h6>
                </div>
                <button class="e-btn w-100 colfff" type="submit" (click)="loginPage()">Login</button>
               </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  